import React from 'react';
import { useTranslation } from 'react-i18next';
import { Transaction } from 'types/rest/assetCatalogTypes';
import BlazeTable from '../../../components/blazeTable/BlazeTable';
import { BlazeTableColDef, BlazeTableOptions } from '../../../components/blazeTable/BlazeTable.types';
import VirtualServiceTypeIcon from '../../../components/icons/VirtualServiceTypeIcon';
import { getColoredHttpMethod } from '../../../utils/commonUtil';
import TransactionEditor from '../Transactions/TransactionEditor/TransactionEditor';
import MessagingEditor from '../Transactions/TransactionEditor/MessagingEditor';

interface Props {
  transactions: Transaction[];
}

const BlueprintTransactionsTable = ({ transactions }: Props) => {
  const { t } = useTranslation('blueprints');

  const columns: BlazeTableColDef[] = [
    {
      header: 'Name',
      accessor: 'name',
      isSortable: true,
      width: 280,
      cellComponent: (txn: Transaction) => (
        <div className="d-flex align-items-center">
          <VirtualServiceTypeIcon type={txn.type} className={'mr-3 align-middle'} />
          {txn.name}
        </div>
      ),
    },
    {
      header: 'Method',
      accessor: 'method',
      isSortable: false,
      width: 100,
      cellComponent: (txn: Transaction) =>
        txn.type === 'MESSAGING'
          ? '-'
          : getColoredHttpMethod('method' in txn.dsl.requestDsl ? (txn.dsl.requestDsl.method as any) : '-'),
    },
    {
      header: 'Request URL',
      accessor: 'url',
      isSortable: false,
      cellComponent: (txn: Transaction) =>
        txn.type === 'MESSAGING' ? (
          '-'
        ) : (
          <code>{'url' in txn.dsl.requestDsl ? txn.dsl.requestDsl.url.matchingValue : '-'}</code>
        ),
    },
    {
      header: 'Status',
      accessor: 'status',
      isSortable: false,
      width: 90,
      cellComponent: (txn: Transaction) =>
        txn.type === 'MESSAGING' ? (
          '-'
        ) : (
          <span>{'status' in txn.dsl.responseDsl ? txn.dsl.responseDsl.status : '-'}</span>
        ),
    },
  ];

  const renderEditor = (txn: Transaction) => {
    const common = {
      transaction: txn,
      serviceId: txn.serviceId,
      isCreate: false,
      isReadOnly: true,
      isEmbedded: true,
      onSave: () => undefined,
    };
    return (
      <div className="p-4">
        {txn.type === 'HTTP' ? <TransactionEditor {...common} /> : <MessagingEditor {...common} />}
      </div>
    );
  };

  const options: BlazeTableOptions = {
    columnDef: columns,
    selectable: false,
    showRowExpander: true,
    expandDetailComponent: (txn: Transaction) => renderEditor(txn),
    pageable: true,
    sortable: true,
    pageSize: 8,
    tableName: 'blueprint-detail-transactions',
    noResultsText: t('detail.noTransactions'),
  };

  return <BlazeTable data={transactions} options={options} />;
};

export default BlueprintTransactionsTable;
